import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Globe icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Globe } from '@sravni/design-system-icons'
 *
 * <Globe />
 * ```
 */
var Globe = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Globe", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 2.5c4.152 0 7.5 3.348 7.5 7.5s-3.348 7.5-7.5 7.5M10 17.5A7.488 7.488 0 0 1 2.5 10c0-4.152 3.348-7.5 7.5-7.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M8.473 3.383c-2.408 4.021-2.408 9.214 0 13.235a1.762 1.762 0 0 0 3.054 0c2.409-4.021 2.409-9.214 0-13.235a1.762 1.762 0 0 0-3.054 0ZM2.5 10h15", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Globe };
//# sourceMappingURL=Globe.js.map
